import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent as UiBaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

import { BaseFilter, BaseFilterMeta } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-base-filters',
  styleUrls: ['./base-filters.component.scss'],
  templateUrl: './base-filters.component.html',
})
export class BaseFiltersComponent extends UiBaseFiltersComponent<BaseFilter, FilterFieldsOptions<BaseFilter>> {
  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, BaseFilterMeta);
  }

}
